import React, { useState, useEffect } from "react";
import Banner from "../components/Banner";
import NewBanner from "../components/NewBanner";
import { motion } from "framer-motion";
import './Home.css'
import { BsFillGrid1X2Fill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { GiPayMoney, GiTakeMyMoney } from "react-icons/gi";
import { VscCombine } from "react-icons/vsc";
import process_line from "../images/process_line.svg";
import Number_Statistics from "../components/Number_Statistics";
import { AiOutlineFileDone } from "react-icons/ai";
import { VscOpenPreview } from "react-icons/vsc";
import { IoMdDoneAll } from "react-icons/io";
import LoanCalculator from "../components/LoanCalculator";
import ChatButton from "../components/ChatButton";
import { FaApple } from "react-icons/fa";
import { DiAndroid } from "react-icons/di";
import { BiSolidCustomize } from "react-icons/bi";
import { SiFsecure } from "react-icons/si";
import { FaStrava } from "react-icons/fa";
import { FaHandsClapping } from "react-icons/fa6";
import { FaDroplet } from "react-icons/fa6";
import { SiWebmoney } from "react-icons/si";
import {
  MdOutlineFileDownload,
  MdOutlineFileUpload,
  MdOutlineDone,
} from "react-icons/md";
import Process from "../components/Process";
import Calculator from "../components/Calculator";
import WhyChoose from "../components/WhyChoose";
import LoanPart from "../pages/LoanPart";
import LoanProcessDiagram from "../pages/LoanProcessDiagram";
import LoanEligibility from "../pages/LoanEligibility";
import LoanCalculate from "./LoanCalculator";
import SortFAQ from "../pages/SortFAQ"
// import Bodyimage from "../images/body-new.png";
import HomePageBanner from "../images/bannerImage.jpg";
import HomePageBanner2 from "../images/HomePageBanner2.png";
import HomeBody1Image from "../images/homebody1.jpg";
import HomeBanner from "../images/HomeBanner.jpg";

import AdvancedBackgroundRemover from '../components/AdvancedBackgroundRemover';
import AnimatedText from '../components/AnimatedText'
import LoanFeatures from "../components/LoanFeatures";
import Testimonial from '../components/Testimonial'
import { APP_NAME } from "../Utils/constant";
import InterestCalculator from "../components/InterestCalculator/Intrestcalculator";

const Home = () => {
  const [step, setStep] = useState(1);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  
  // Testimonials Carousel State
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  
  // Testimonials Data
  const testimonials = [
    {
      name: "Priya Sharma",
      location: "Mumbai, Maharashtra",
      loan: "₹75,000",
      rating: 5,
      text: "Udhaar Portal saved me during a medical emergency. The process was so smooth and I got the money in my account within 2 hours. Their customer support is excellent!",
      avatar: "👩‍💼",
      verified: true
    },
    {
      name: "Rajesh Kumar",
      location: "Delhi, NCR",
      loan: "₹50,000",
      rating: 5,
      text: "I was skeptical about online loans, but Udhaar Portal proved me wrong. No hidden charges, transparent process, and the interest rates are very reasonable.",
      avatar: "👨‍💻",
      verified: true
    },
    {
      name: "Anita Patel",
      location: "Ahmedabad, Gujarat",
      loan: "₹1,00,000",
      rating: 5,
      text: "The best part is the instant approval. I applied in the morning and by evening I had the money. The documentation process was minimal and hassle-free.",
      avatar: "👩‍🎓",
      verified: true
    },
    {
      name: "Vikram Singh",
      location: "Bangalore, Karnataka",
      loan: "₹60,000",
      rating: 5,
      text: "Excellent service! The team was very helpful throughout the process. I would definitely recommend Udhaar Portal to anyone looking for quick loans.",
      avatar: "👨‍🔧",
      verified: true
    },
    {
      name: "Sneha Reddy",
      location: "Hyderabad, Telangana",
      loan: "₹40,000",
      rating: 5,
      text: "I needed money urgently for my daughter's education. Udhaar Portal came to my rescue with their quick processing and competitive rates.",
      avatar: "👩‍🏫",
      verified: true
    },
    {
      name: "Amit Verma",
      location: "Pune, Maharashtra",
      loan: "₹80,000",
      rating: 5,
      text: "The mobile app is user-friendly and the entire process is digital. No need to visit any office. Highly recommended for busy professionals like me.",
      avatar: "👨‍💼",
      verified: true
    }
  ];
  
  // Carousel Functions
  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };
  
  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };
  
  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(nextTestimonial, 5000);
    return () => clearInterval(interval);
  }, []);
  
  // Personal Loan Calculator State
  const [loanAmount, setLoanAmount] = useState(25000);
  const [tenure, setTenure] = useState(15);
  const [interestRate, setInterestRate] = useState(0.5); // 0.5% per day
  const [calculatedAmount, setCalculatedAmount] = useState(0);
  
  // Debug: Log the image import
  console.log('HomeBody1Image:', HomeBody1Image);
  console.log('HomePageBanner2:', HomePageBanner2);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  // Loading effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  // Personal Loan Calculation
  useEffect(() => {
    const calculatePersonalLoan = () => {
      // Interest rate is already per day (0.5% to 2% per day)
      const dailyRate = interestRate / 100; // Convert percentage to decimal
      const interestAmount = (loanAmount * dailyRate * tenure);
      const processingFee = 500;
      const totalAmount = loanAmount + interestAmount + processingFee;
      setCalculatedAmount(Math.round(totalAmount));
    };
    
    calculatePersonalLoan();
  }, [loanAmount, tenure, interestRate]);

  // Update calculator display when values change
  useEffect(() => {
    const formatCurrency = (amount) => `₹${amount.toLocaleString('en-IN')}`;
    
    // Update all display elements
    const updateElement = (id, value) => {
      const element = document.getElementById(id);
      if (element) element.textContent = value;
    };

    updateElement('loanAmountValue', formatCurrency(loanAmount));
    updateElement('interestRateValue', `${interestRate}% per day`);
    updateElement('repaymentDaysValue', `${tenure} Days`);
    updateElement('principalAmount', formatCurrency(loanAmount));
    updateElement('interestRateDisplay', `${interestRate}% per day`);
    
    const dailyRate = interestRate / 100; // Convert percentage to decimal
    const interestAmount = (loanAmount * dailyRate * tenure);
    updateElement('interestAmount', formatCurrency(Math.round(interestAmount)));
    
    const totalPayable = loanAmount + interestAmount + 500;
    updateElement('totalPayable', formatCurrency(Math.round(totalPayable)));
    updateElement('resultAmount', formatCurrency(Math.round(totalPayable)));
    updateElement('resultSubtext', `Due in ${tenure} days`);
  }, [loanAmount, tenure, interestRate, calculatedAmount]);

  // Handle loan amount change
  const handleLoanAmountChange = (value) => {
    const amount = Math.max(5000, Math.min(100000, parseInt(value)));
    setLoanAmount(amount);
  };

  // Handle tenure change
  const handleTenureChange = (value) => {
    const days = Math.max(7, Math.min(30, parseInt(value)));
    setTenure(days);
  };

  // Handle interest rate change
  const handleInterestRateChange = (value) => {
    const rate = Math.max(0.25, Math.min(2.0, parseFloat(value)));
    setInterestRate(rate);
  };

  const advantages = [
    {
      title: "Easy Application",
      content: `Gone are the days when the loan application process was itself a headache. Now, you need not visit a bank and sign a bundle of documents because we allow online paperless loan applications with minimum documentation. Don't stand in the long queue at your nearest bank, instead open the ${APP_NAME} app and complete the application process in the blink of an eye.`
    },
    {
      title: "Prompt Approval",
      content: `As soon as we receive a loan application, we immediately swing into action. We meticulously review the loan application and if everything is good to go, we instantly approve it in a flash. ${APP_NAME} understands how important your time is, which is why we believe in prompt approval and super-fast bank transfers.`
    },
    {
      title: "Ultrafast Loan Disbursal",
      content: `The reason why ${APP_NAME} has made a special name for itself is its ultrafast loan disbursal feature. We are as fast as a lightning bolt in transferring the loan amount directly to your bank account. Once the loan is approved by our team, we waste no time in disbursing the amount.`
    },
    {
      title: "No Hidden Charges",
      content: `Hidden charges may come as a shock, making you sceptical about whether to take the loan or not. At ${APP_NAME}, we aim to simplify your financial complications with our 'No Hidden Charges' policy that makes things transparent.`
    },
    {
      title: "Easy-to-Repay Options",
      content: "We want to be the helping hand in your lean patch. Therefore, customer satisfaction is at the top of our priority list. We offer personalized loan terms and flexible repayment options to ensure that repaying the loan amount never feels like a burden."
    },
    {
      title: "Customized Personal Loans",
      content: "We know that circumstances may differ from person to person. Therefore, loan requirements may significantly vary. Keeping this in mind, we offer a wide range of loan options to fit every loan requirement."
    }
  ];
  
  return (
    <React.Fragment>
      {/* Loading Screen */}
      {isLoading && (
        <motion.div 
          className="loading-screen"
          initial={{ opacity: 1 }}
          animate={{ opacity: 0 }}
          transition={{ duration: 0.5, delay: 1.5 }}
          style={{ 
            position: 'fixed', 
            top: 0, 
            left: 0, 
            right: 0, 
            bottom: 0, 
            background: 'linear-gradient(135deg, #2D5A27 0%, #4A7C59 100%)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
          }}
        >
          {/* <motion.div
            className="loading-logo"
            animate={{ 
              scale: [1, 1.1, 1],
              rotate: [0, 5, -5, 0]
            }}
            transition={{ 
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            style={{
              fontSize: '4rem',
              color: 'white',
              marginBottom: '2rem',
              textShadow: '0 0 20px rgba(255, 255, 255, 0.5)'
            }}
          >
            ₹
          </motion.div> */}
          <motion.h1
            style={{ 
              color: 'white', 
              fontSize: '2rem', 
              fontWeight: 'bold',
              textAlign: 'center',
              marginBottom: '1rem'
            }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            Udhaar Portal
          </motion.h1>
          <motion.div
            className="loading-bar"
            style={{
              width: '200px',
              height: '4px',
              background: 'rgba(255, 255, 255, 0.3)',
              borderRadius: '2px',
              overflow: 'hidden'
            }}
          >
            <motion.div
              style={{
                height: '100%',
                background: 'linear-gradient(90deg, #4A7C59, #2D5A27)',
                borderRadius: '2px'
              }}
              initial={{ width: '0%' }}
              animate={{ width: '100%' }}
              transition={{ duration: 2, ease: "easeInOut" }}
            />
          </motion.div>
        </motion.div>
      )}

      <motion.div 
        className="page_wrappers"
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoading ? 0 : 1 }}
        transition={{ duration: 0.5, delay: isLoading ? 0 : 0.5 }}
      >
        {/* New Banner Section */}
        <NewBanner />

        {/* What We Do Section */}
        <section className="what-we-do-section">
          <div className="what-we-do-container">
              <motion.div 
              className="what-we-do-header"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="what-we-do-title">
                What We <span className="highlight-what">Offer</span>
              </h2>
              <p className="what-we-do-subtitle">
At Udhaar
Portal, we offer wide range of
unsecured loans to meet your
all your financial needs.              </p>
            </motion.div>

            <div className="what-we-do-content">
              <motion.div 
                className="what-we-do-main"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <div className="main-content-card">
                  {/* <div className="content-icon">💡</div> */}
                  <h3 className="content-title">Instant Personal Loans</h3>
                  <p className="content-description">
                    We provide quick, hassle-free Personal loans ranging from ₹5,000 to ₹1,00,000. 
                    When life throws unexpected expenses your way - medical emergencies, urgent repairs, 
                    or any immediate financial need - we're here to help you bridge the gap.
                  </p>
                  {/* <div className="content-features">
                    <div className="feature-point">✓ Same-day approval</div>
                    <div className="feature-point">✓ No lengthy paperwork</div>
                    <div className="feature-point">✓ Flexible repayment options</div>
                </div> */}
            </div>
              </motion.div>

              <motion.div 
                className="what-we-do-details"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <div className="details-grid">
                  <div className="detail-card">
                    <div className="detail-icon"></div>
                    <h4>Salary Advance</h4>
                    <p>
                    Access a part of your salary
before earning day to manage
monthly expenses and unexpected needs. </p>
                   </div>
                    
                  <div className="detail-card">
                    <div className="detail-icon"></div>
                    <h4> Medical Loan</h4>
                    <p>
                Get immediate financial
support for medical
emergencies with quick &
paperless approvals.</p>                      </div>
                      
                  <div className="detail-card">
                    <div className="detail-icon"></div>
                    <h4>Household Emergency</h4>
                    <p>
                    Quick funds to cover
urgent household expenses
such as repairs, utility
payments, or essential
purchases. </p> 
                     </div>

                  <div className="detail-card">
                    <div className="detail-icon"></div>
                    <h4>Transparent Pricing</h4>
                    <p>Clear, upfront pricing with no hidden charges. You know exactly what you'll pay before you apply.</p>
                        </div>
                        </div>
              </motion.div>
                      </div>
                      
            <motion.div 
              className="what-we-do-stats"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="stats-container">
                <div className="stat-item">
                  <div className="stat-number">50,000+</div>
                  <div className="stat-label">Happy Customers</div>
                      </div>
                <div className="stat-item">
                  <div className="stat-number">₹500 Cr+</div>
                  <div className="stat-label">Loans Disbursed</div>
                    </div>
                <div className="stat-item">
                  <div className="stat-number">99.5%</div>
                  <div className="stat-label">Customer Satisfaction</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">24/7</div>
                  <div className="stat-label">Customer Support</div>
                  </div>
                </div>
              </motion.div>
          </div>
        </section>

        {/* Why Choose Udhaar Portal - Modern Card Design */}
        <section className="why-choose-modern-section">
          <div className="why-choose-modern-container">
            <motion.div 
              className="why-choose-modern-header"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="why-choose-modern-title">
                Why Choose <span className="highlight-modern">Udhaar Portal</span>?
              </h2>
              {/* <p className="why-choose-modern-subtitle">
                Join thousands of satisfied customers who trust us for their financial needs
              </p> */}
            </motion.div>
            
            <div className="why-choose-modern-grid">
              <motion.div 
                className="why-choose-modern-card"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="card-icon-modern">⚡</div>
                <h3 className="card-title-modern">Same-day disbursal</h3>
                {/* <p className="card-description-modern">
                  Get approved in under 30 minutes with our advanced AI system that processes your application instantly.
                </p>
                <div className="card-stats-modern">
                  <span className="stat-modern">30 min</span>
                  <span className="stat-label-modern">Approval Time</span>
                </div> */}
              </motion.div>

         

              <motion.div 
                className="why-choose-modern-card"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="card-icon-modern">📱</div>
                <h3 className="card-title-modern">100% Paper Less & Online</h3>
             
              </motion.div>

              <motion.div 
                className="why-choose-modern-card"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="card-icon-modern">₹</div>
                <h3 className="card-title-modern">No Hidden & Foreclosure Charges</h3>
               
              </motion.div>

              <motion.div 
                className="why-choose-modern-card"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.5 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="card-icon-modern">📋</div>
                <h3 className="card-title-modern">Easy Documentation</h3>
               
              </motion.div>

              <motion.div 
                className="why-choose-modern-card"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="card-icon-modern">🎯</div>
                <h3 className="card-title-modern">Customer Support</h3>
               
              </motion.div>
            </div>
          </div>
        </section>

        {/* Why Choose Us Section - Horizontal Banner Style */}
        <section className="why-choose-section">
          <div className="why-choose-container">
            <motion.div 
              className="why-choose-header"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="why-choose-title">
                <span className="highlight">How to apply</span>
              </h2>
              <p className="why-choose-subtitle">
                Experience the future of instant loans with our cutting-edge platform
              </p>
            </motion.div>
            
            {/* Content Section */}
            <div className="why-choose-content-layout">
              {/* Content Section */}
              <motion.div 
                className="content-section-centered"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <div className="content-header">
                  <h3>Get Started in 3 Steps</h3>
                  <p>Simple process, instant results.</p>
                </div>
                
                <div className="simple-steps">
                  <div className="step-top">
                    <div className="step-number">1</div>
                    <div className="step-text">
                      <h4>Apply Online</h4>
                      <p>Fill basic details in 2 minutes</p>
                    </div>
                  </div>
                  
                  <div className="steps-bottom">
                    <div className="step-item">
                      <div className="step-number">2</div>
                      <div className="step-text">
                        <h4>Get Approved</h4>
                        <p>AI reviews and approves instantly</p>
                      </div>
                    </div>
                    
                    <div className="step-item">
                      <div className="step-number">3</div>
                      <div className="step-text">
                        <h4>Receive Money</h4>
                        <p>Funds transferred to your account</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="cta-button-container">
                  <Link to="/apply-now" className="modern-apply-btn">
                    <span className="btn-text">Apply Now</span>
                    <span className="btn-icon">→</span>
                  </Link>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Calculator and Eligibility Section */}
        <section className="calculator-eligibility-section">
          <div className="calculator-eligibility-container">
            
            {/* Calculator Card */}
            <div className="calculator-wrapper">
              <div className="loan-calculator-card">
        <h2 className="calculator-title">Personal Loan Calculator</h2>
        <p className="calculator-subtitle">
          Quick cash when you need it most - Calculate your instant loan
        </p>

        <div className="calculator-inputs">
          <div className="input-group">
            <label className="input-label">Loan Amount (₹)</label>
            <input
              type="range"
              className="input-range"
              min="5000"
              max="100000"ˀ
              step="1000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              id="loanAmount"
            />
            <div className="range-value" id="loanAmountValue">₹25,000</div>
                    </div>
          <div className="input-group">
            <label className="input-label">Interest Rate (%)</label>
            <input
              type="range"
              className="input-range"
              min="0.5"
              max="2"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              id="interestRate"
            />
            <div className="range-value" id="interestRateValue">0.5% per day</div>
                  </div>
          <div className="input-group">
            <label className="input-label">Repayment Days</label>
            <input
              type="range"
              className="input-range"
              min="7"
              max="30"
              step="1"
              value={tenure}
              onChange={(e) => setTenure(parseInt(e.target.value))}
              id="repaymentDays"
            />
            <div className="range-value" id="repaymentDaysValue">15 Days</div>
                </div>
                        </div>

        <div className="calculator-details">
          <div className="detail-row">
            <span className="detail-label">Principal Amount:</span>
            <span className="detail-value" id="principalAmount">₹25,000</span>
                        </div>
          <div className="detail-row">
            <span className="detail-label">Interest Rate:</span>
            <span className="detail-value" id="interestRateDisplay">0.5% per day</span>
                    </div>
          <div className="detail-row">
            <span className="detail-label">Processing Fee:</span>
            <span className="detail-value">*₹500</span>
                  </div>
          <div className="detail-row">
            <span className="detail-label">Interest Amount:</span>
            <span className="detail-value" id="interestAmount">₹1,875</span>
                </div>
          <div className="detail-row total-row">
            <span className="detail-label">Total Payable:</span>
            <span className="detail-value" id="totalPayable">₹27,375</span>
              </div>
            </div>
            
        <div className="calculator-result">
          <div className="result-amount" id="resultAmount">₹27,375</div>
          <div className="result-label">Total Amount to Repay</div>
          <div className="result-subtext" id="resultSubtext">Due in 15 days</div>
          </div>

        <Link to="/apply-now" className="calculator-button">
          Apply Now
        </Link>
        
              </div>
            </div>

            {/* Eligibility Card */}
            <div className="eligibility-wrapper">
              <div className="eligibility-section-header">
                <h2 className="eligibility-title">
                  Eligibility & <span className="highlight">Documents</span>
                </h2>
                <p className="eligibility-subtitle">
                  Simple requirements for quick approval
                </p>
              </div>
              <div className="info-card eligibility-card">
                <div className="card-header">
                  <h3>Requirements</h3>
                </div>
                <div className="card-content">
                  <p className="card-intro">
                    Our digital verification process through Aadhaar and PAN is secure, encrypted, and follows all government norms.
                  </p>
                  <div className="criteria-list">
                    <div className="criteria-item">
                      <h4>Age</h4>
                      <p>Applicants must be at least 21 and at max 55 years old.</p>
                    </div>
                    <div className="criteria-item">
                      <h4>Documentation</h4>
                      <p>Pan Card, Aadhar Card, Bank Statement, Salary Slip.</p>
                    </div>
                    <div className="criteria-item">
                      <h4>Profile</h4>
                      <p>Must be Indian Citizen, Salaried with a reputed company.</p>
                    </div>
                    <div className="criteria-item">
                      <h4>Residency</h4>
                      <p>Applicants must reside in the country where Udhaar Portal operates.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="testimonials-container">
            <motion.div 
              className="section-header"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">
                What Our <span className="highlight">Customers Say</span>
              </h2>
              <p className="section-subtitle">
                Real stories from real people who trusted us with their financial needs
              </p>
              </motion.div>

            <div className="testimonials-carousel">
              <motion.div 
                className="testimonial-card"
                key={currentTestimonial}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.5 }}
              >
                <div className="testimonial-header">
                  <div className="customer-info">
                    <div className="customer-avatar">{testimonials[currentTestimonial].avatar}</div>
                    <div className="customer-details">
                      <h4 className="customer-name">{testimonials[currentTestimonial].name}</h4>
                      <p className="customer-location">{testimonials[currentTestimonial].location}</p>
                      {testimonials[currentTestimonial].verified && (
                        <div className="verified-badge">
                          <span className="verified-icon">✓</span>
                          <span className="verified-text">Verified Customer</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="loan-amount">
                    <span className="amount-label">Loan Amount</span>
                    <span className="amount-value">{testimonials[currentTestimonial].loan}</span>
                  </div>
                </div>

                <div className="testimonial-rating">
                  {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                    <span key={i} className="star">⭐</span>
                  ))}
                </div>

                <blockquote className="testimonial-text">
                  "{testimonials[currentTestimonial].text}"
                </blockquote>
              </motion.div>
              
              {/* Carousel Controls */}
              <div className="carousel-controls">
                <button className="carousel-btn prev-btn" onClick={prevTestimonial}>
                  ‹
                </button>
                <div className="carousel-dots">
                  {testimonials.map((_, index) => (
                    <button
                      key={index}
                      className={`carousel-dot ${index === currentTestimonial ? 'active' : ''}`}
                      onClick={() => setCurrentTestimonial(index)}
                    />
                  ))}
                </div>
                <button className="carousel-btn next-btn" onClick={nextTestimonial}>
                  ›
                </button>
              </div>
            </div>


            <motion.div 
              className="testimonials-cta"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="cta-content">
                <h3 className="cta-title">Ready to Join Our Happy Customers?</h3>
                <p className="cta-subtitle">Experience the same fast, secure, and reliable service</p>
                <Link to="/apply-now" className="testimonial-cta-btn">
                  <span className="btn-icon">🚀</span>
                  <span className="btn-text">Apply Now</span>
                  <span className="btn-arrow">→</span>
                </Link>
              </div>
            </motion.div>

            {/* NBFC Partner Section */}
            {/* <motion.div 
              className="nbfc-partner-section"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1.0 }}
              viewport={{ once: true }}
            >
              <div className="nbfc-partner-content">
                <h3 className="nbfc-partner-title">NBFC Partner</h3>
                <div className="nbfc-partner-card">
                  <div className="nbfc-partner-info">
                    <h4 className="nbfc-partner-name">Focus Industrial Resources Limited</h4>
                    <p className="nbfc-partner-description">
                      Licensed and regulated by RBI, ensuring secure and compliant financial services
                    </p>
                  </div>
                  <div className="nbfc-partner-badge">
                    <span className="nbfc-badge-text">Verified Partner</span>
                    <span className="nbfc-badge-icon">✓</span>
                  </div>
                </div>
              </div>
            </motion.div> */}
          </div>
        </section>

        {/* FAQ Section */}
        <section className="home-faq-section">
          <div className="home-faq-container">
            <motion.div 
              className="home-faq-header"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="home-faq-title">
                Frequently Asked <span className="home-faq-highlight">Questions</span>
              </h2>
              <p className="home-faq-subtitle">
                Get answers to common questions about our loan services
              </p>
            </motion.div>

            <div className="home-faq-grid">
              <motion.div 
                className="home-faq-item"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.1 }}
                viewport={{ once: true }}
              >
                <div className="home-faq-question">
                  <h3>What is the maximum loan amount I can get?</h3>
                  <span className="home-faq-icon">+</span>
                </div>
                <div className="home-faq-answer">
                  <p>You can get personal loans up to ₹1 lakh with our instant approval process. The exact amount depends on your income, credit score, and repayment capacity.</p>
                </div>
              </motion.div>

              <motion.div 
                className="home-faq-item"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <div className="home-faq-question">
                  <h3>How quickly can I get my loan approved?</h3>
                  <span className="home-faq-icon">+</span>
                </div>
                <div className="home-faq-answer">
                  <p>Our advanced technology enables instant loan approval within minutes. Once approved, funds are transferred directly to your bank account within 24 hours.</p>
                </div>
              </motion.div>

              <motion.div 
                className="home-faq-item"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <div className="home-faq-question">
                  <h3>What documents do I need to apply?</h3>
                  <span className="home-faq-icon">+</span>
                </div>
                <div className="home-faq-answer">
                  <p>You need minimal documentation: Aadhaar card, PAN card, bank statements (3 months), and salary slips. Our digital process makes document submission quick and easy.</p>
                </div>
              </motion.div>

              <motion.div 
                className="home-faq-item"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <div className="home-faq-question">
                  <h3>What are the loan terms and conditions?</h3>
                  <span className="home-faq-icon">+</span>
                </div>
                <div className="home-faq-answer">
                  <p>Our loan terms are flexible and vary based on your credit profile, loan amount, and repayment capacity. We offer competitive terms with transparent pricing and no hidden charges.</p>
                </div>
              </motion.div>

              <motion.div 
                className="home-faq-item"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.5 }}
                viewport={{ once: true }}
              >
                <div className="home-faq-question">
                  <h3>Is my personal information secure?</h3>
                  <span className="home-faq-icon">+</span>
                </div>
                <div className="home-faq-answer">
                  <p>Yes, we use bank-level security with 256-bit SSL encryption. Your data is protected and we comply with RBI guidelines and data protection regulations.</p>
                </div>
              </motion.div>

              <motion.div 
                className="home-faq-item"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
                viewport={{ once: true }}
              >
                <div className="home-faq-question">
                  <h3>Can I prepay my loan without charges?</h3>
                  <span className="home-faq-icon">+</span>
                </div>
                <div className="home-faq-answer">
                  <p>Yes, you can prepay your loan partially or fully without any prepayment charges. This helps you save on interest and close your loan early.</p>
                </div>
              </motion.div>
            </div>

            <motion.div 
              className="home-faq-cta"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.7 }}
              viewport={{ once: true }}
            >
              <div className="home-faq-cta-content">
                <h3 className="home-faq-cta-title">Still have questions?</h3>
                <p className="home-faq-cta-subtitle">Our support team is here to help you 24/7</p>
                <div className="home-faq-cta-buttons">
                  <Link to="/contact" className="home-faq-cta-btn home-faq-cta-primary">
                    <span className="btn-icon">💬</span>
                    <span className="btn-text">Contact Support</span>
                  </Link>
                  <Link to="/faq" className="home-faq-cta-btn home-faq-cta-secondary">
                    <span className="btn-icon">❓</span>
                    <span className="btn-text">View All FAQs</span>
                  </Link>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
      </motion.div>
      </React.Fragment>
    );
  };

export default Home;